import React, { useContext } from "react";
import Context from "../context";
import {
	Box,
	Grid,
	Paper,
	Typography,
	Button,
	Avatar,
	Fab,
} from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import MachinesScreenMobile from "../screens/machines-screen-mobile";
import LogoutIcon from "@mui/icons-material/Logout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import authService from "../services/auth-service";
import { useTranslation } from "react-i18next";

export default function PerfilMobile() {
	const user = useContext(Context);
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleLogout = () => {
		authService.logout();
		navigate("/login");
	};

	return (
		<Box
			sx={{
				width: "100vw",
				minHeight: "100vh",

				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column",
				overflow: "hidden",
			}}>
			{/* Floating back button */}


			{/* Profile Card */}
			<Box sx={{ mt: 10 }}>

				{/* User Info */}
				<Typography
					variant="h4"
					fontWeight="bold"
					sx={{
						color: "#4A4A4A",
						textShadow: "1px 1px 6px rgba(0, 0, 0, 0.2)",
					}}>
					{user?.name}
				</Typography>
				<Typography
					variant="h6"
					sx={{ color: "#8C8C8C", fontWeight: 300, mt: 1, mb: 1 }}>
					{user?.email}
				</Typography>
				<Typography
					variant="subtitle2"
					sx={{
						color: "#6E45E2",
						fontWeight: "bold",
						textTransform: "uppercase",
						letterSpacing: "1.5px",
					}}>
					{t("COMMON.ROLE_TECHNICIAN")}
				</Typography>



				{/* Logout Button */}
				<Button
					variant="contained"
					color="error"
					startIcon={<LogoutIcon />}
					onClick={handleLogout}
					sx={{
						mt: 1,
						width: "40%",
						bgcolor: "#FF6565",
						color: "#fff",
						fontWeight: "bold",
						padding: "12px 16px",
						borderRadius: "50px",
						boxShadow: "0px 10px 15px rgba(255, 101, 101, 0.5)",
						transition: "all 0.3s ease-in-out",
						"&:hover": {
							bgcolor: "#FF8888",
							boxShadow: "0px 15px 20px rgba(255, 101, 101, 0.8)",
							transform: "translateY(-2px)",
						},
					}}>
					{t("AUTH.LOGOUT")}
				</Button>
			</Box>

			{/* Machine List Below */}
			<Grid item mt={5}>
				<MachinesScreenMobile />
			</Grid>
		</Box>
	);
}
